import {IsNumber, IsOptional, IsString} from 'class-validator';

export class XmaTextGenerationDto {
  @IsString()
  text!: string;

  @IsOptional()
  @IsNumber()
  style?: number | null;

  @IsOptional()
  @IsNumber()
  length?: number | null;

  @IsOptional()
  @IsNumber()
  goal?: number | null;

  @IsOptional()
  @IsString()
  businessName?: string;

  @IsOptional()
  @IsString()
  businessTagline?: string;

  @IsOptional()
  @IsString()
  businessContactNumber?: string;

  @IsOptional()
  @IsString()
  businessUrl?: string;

  @IsOptional()
  @IsString()
  businessActivity?: string;
}
